import { render, staticRenderFns } from "./RemotePowerSupply.vue?vue&type=template&id=27133350&scoped=true&"
import script from "./RemotePowerSupply.vue?vue&type=script&lang=ts&"
export * from "./RemotePowerSupply.vue?vue&type=script&lang=ts&"
import style0 from "./RemotePowerSupply.vue?vue&type=style&index=0&id=27133350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27133350",
  null
  
)

/* custom blocks */
import block0 from "./RemotePowerSupply.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports